import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface Testimonial {
  name: string;
  business: string;
  image?: string;
  rating: number;
  text: string;
  result: string;
  location: string;
}

const testimonials: Testimonial[] = [
  {
    name: "Carlos Mendoza",
    business: "FitZone Barcelona",
    rating: 5,
    text: "Desde que nos hicimos Premium en Ekselencia, nuestras consultas aumentaron un 320%. La visibilidad es increíble y el ROI fue inmediato.",
    result: "+320% consultas en 2 meses",
    location: "Barcelona, España"
  },
  {
    name: "Ana García",
    business: "Yoga Studio Madrid",
    rating: 5,
    text: "El sistema de leads de Ekselencia transformó nuestro negocio. Pasamos de 5 clientes nuevos al mes a más de 40. ¡Totalmente recomendado!",
    result: "+700% clientes nuevos",
    location: "Madrid, España"
  },
  {
    name: "Miguel Ángel Torres",
    business: "CrossFit Valencia",
    rating: 5,
    text: "La inversión en Premium se pagó sola en menos de 3 semanas. Ahora somos el gimnasio más visible en Valencia y nuestras membresías no paran de crecer.",
    result: "ROI recuperado en 3 semanas",
    location: "Valencia, España"
  },
  {
    name: "Laura Martínez",
    business: "Pilates & Wellness",
    rating: 5,
    text: "Como entrenadora personal, Ekselencia me dio la plataforma perfecta para destacar. Ahora tengo agenda completa y lista de espera.",
    result: "Agenda completa en 1 mes",
    location: "Sevilla, España"
  }
];

export const TestimonialsSection = () => {
  return (
    <section className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Resultados Reales de <span className="gradient-text">Profesionales Reales</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            No promesas vacías. Historias verificables de negocios que crecen con Ekselencia.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="relative hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <Quote className="w-8 h-8 text-primary/20 mb-4" />
                
                {/* Rating */}
                <div className="flex gap-1 mb-4">
                  {Array.from({ length: testimonial.rating }).map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-primary text-primary" />
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="text-sm text-foreground mb-4 italic">
                  "{testimonial.text}"
                </p>

                {/* Result Badge */}
                <div className="bg-primary/10 text-primary text-xs font-bold px-3 py-1.5 rounded-full inline-block mb-4">
                  {testimonial.result}
                </div>

                {/* Author */}
                <div className="mt-4 pt-4 border-t">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-gradient-primary flex items-center justify-center text-white font-bold">
                      {testimonial.name.charAt(0)}
                    </div>
                    <div>
                      <p className="font-semibold text-sm">{testimonial.name}</p>
                      <p className="text-xs text-muted-foreground">{testimonial.business}</p>
                      <p className="text-xs text-muted-foreground">{testimonial.location}</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust Stats */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          <div>
            <div className="text-3xl font-bold gradient-text">1,000+</div>
            <div className="text-sm text-muted-foreground">Negocios Activos</div>
          </div>
          <div>
            <div className="text-3xl font-bold gradient-text">98%</div>
            <div className="text-sm text-muted-foreground">Satisfacción</div>
          </div>
          <div>
            <div className="text-3xl font-bold gradient-text">250%</div>
            <div className="text-sm text-muted-foreground">ROI Promedio</div>
          </div>
          <div>
            <div className="text-3xl font-bold gradient-text">24h</div>
            <div className="text-sm text-muted-foreground">Soporte</div>
          </div>
        </div>
      </div>
    </section>
  );
};
